<template>
  <a-modal
      title="修改专家状态"
      :visible="stateVisible"
      :maskClosable="false"
      :width="960"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <a-form-model :model="stateForm" ref="stateForm" :rules="rules" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="20"
             type="flex"
             align="middle">
        <a-form-model-item label="专家状态" prop="state">
          <a-radio-group v-model="stateForm.state">
            <a-radio-button v-for="(item, index) in SelectExpertStateArr" :value="item.value">{{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!--      出库-->
        <template v-if="stateForm.state === SelectExpertStateArr[1].value">
          <a-form-model-item label="出库时间" prop="stockOutDate">
            <a-date-picker v-model="stateForm.stockOutDate"
                           :format="dateFormatStr"
                           style="width: 100%"/>
          </a-form-model-item>
          <a-form-model-item label="出库理由" prop="stockOutReason">
            <a-textarea
                placeholder="请填写出库理由"
                :atow-size="{minSize:3,maxSize:5}"
                v-model="stateForm.stockOutReason"/>
          </a-form-model-item>
        </template>
        <!--      休假-->
        <template v-if="stateForm.state === SelectExpertStateArr[2].value">
          <a-col :span="10">
            <a-form-model-item label="休假开始时间"
                               prop="notExtractStartTime">
              <a-date-picker class="w-100"
                             v-model="stateForm.notExtractStartTime"
                             :disabled-date="disabledStartDate"
                             :format="dateFormatStr"
                             placeholder="开始时间"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="休假结束时间" prop="notExtractEndTime"
                               :rules="[{ required: !stateForm.leaveRecordType, message: '请输入休假结束时间', trigger: 'change' }]">
              <a-date-picker class="w-100"
                             v-if="!stateForm.leaveRecordType"
                             v-model="stateForm.notExtractEndTime"
                             :disabled-date="disabledEndDate"
                             :format="dateFormatStr"
                             placeholder="结束时间"/>
              <span class="color-red"
                    v-else>长期</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-checkbox v-model="stateForm.leaveRecordType">
              长期休假
            </a-checkbox>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="休假原因"
                               prop="leaveReason">
              <a-textarea v-model="stateForm.leaveReason"
                          :atow-size="{minSize:3,maxSize:5}"
                          placeholder="请输入休假原因"/>
            </a-form-model-item>
          </a-col>
        </template>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { ExpertState, SelectExpertStateArr } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import moment from 'moment'
import { UpdateStateExpertById } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

const rules = {
  state: [{ required: true, message: '专家类型不能为空！', trigger: 'change' }],
  stockOutDate: [{ required: true, message: '出库时间不能为空！', trigger: 'change' }],
  stockOutReason: [{ required: true, message: '请输入出库理由', trigger: 'change' }],
  leaveReason: [{ required: true, message: '请输入休假原因', trigger: 'change' }],
  notExtractStartTime: [{ required: true, message: '请输入休假开始时间', trigger: 'change' }],
}

export default {
  name: 'EditExpertStateModal',
  computed: {},
  components: {},
  props: {
    stateVisible: {
      type: Boolean,
      default: false
    },
    expertInfo: {
      type: Object,
      default: () => {
        return {
          state: undefined
        }
      }
    }
  },
  data () {
    return {
      dateFormatStr: 'YYYY-MM-DD',
      SelectExpertStateArr,
      rules: rules,
      loading: false,
      stateForm: {}
    }
  },
  watch: {
    stateVisible (val) {
      if (val) {
        this.stateForm = {
          ...this.expertInfo,
          leaveRecordType: this.expertInfo.notExtractStartTime && !this.expertInfo.notExtractEndTime
        }
      }
    },
    'stateForm.leaveRecordType' (val) {
      if (val) {
        this.stateForm.notExtractEndTime = null
        this.stateForm.notExtractStartTime = this.stateForm.notExtractStartTime || moment().format(this.dateFormatStr)
        this.$refs.stateForm && this.$refs.stateForm.clearValidate('notExtractEndTime')
        this.$refs.stateForm && this.$refs.stateForm.clearValidate('notExtractStartTime')
      }
    }

  },
  methods: {
    disabledStartDate (current) {
      const endValue = this.stateForm.notExtractEndTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (endValue) {
        let endMoment = moment(moment(endValue).format('YYYY-MM-DD'))
        return currentDay && currentDay < perDay || currentDay > endMoment
      }
      return currentDay && currentDay < perDay
    },
    disabledEndDate (current) {
      const startValue = this.stateForm.notExtractStartTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (startValue) {
        let startMoment = moment(moment(startValue).format('YYYY-MM-DD'))
        return currentDay < startMoment
      }
      return currentDay && currentDay < perDay
    },
    isMoment (obj) {
      return moment.isMoment(obj)
    },
    //回传输入的值
    onSave () {
      let that = this
      this.$refs.stateForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          that.loading = true
          const data = { ...that.stateForm }
          // 正常状态把休假数据清空
          if (ExpertState.STATE.IN_SUCCESS === data.state) {
            data.notExtractStartTime = undefined
            data.notExtractEndTime = undefined
            data.leaveReason = undefined
          } else {
            data.notExtractStartTime = that.isMoment(data.notExtractStartTime) ? data.notExtractStartTime.format(that.dateFormatStr) : data.notExtractStartTime
            data.notExtractEndTime = that.isMoment(data.notExtractEndTime) ? data.notExtractEndTime.format(that.dateFormatStr) : data.notExtractEndTime
          }
          data.stockOutDate = that.isMoment(data.stockOutDate) ? data.stockOutDate.format(that.dateFormatStr) : data.stockOutDate
          let res = await UpdateStateExpertById(data)
          if (200 !== res.code) {
            that.$message.error('状态修改失败')
            return
          }
          that.$message.success('状态修改成功')
          that.$emit('success')
        } catch (e) {
          that.$message.error(e.message)
        } finally {
          that.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
